import { saveAs } from 'file-saver';

const UPLOADS_URL = '/admin/aidentified-uploads';

const getFormData = (tenantId, file) => {
  const formData = new FormData();
  formData.append('tenantId', tenantId);
  formData.append('file', file);
  return formData;
};

// A rejected file comes with a reason to show; a format error also names the missing columns.
const getFileError = async response => {
  const data = await response.json().catch(() => ({}));
  const error = new Error(data.error ?? data.message ?? '');
  error.missingColumns = data.missingColumns;
  error.missingColumnsCount = data.missingColumnsCount;
  return error;
};

const downloadFile = async (url, fileName) => {
  const response = await fetch(url);
  if (response.status !== 200) throw new Error();

  saveAs(await response.blob(), fileName);
};

export const getActiveClients = async () => {
  const response = await fetch('/admin/get-active-clients');
  if (response.status !== 200) throw new Error();

  const data = await response.json();
  return data.clients;
};

export const getAidentifiedUploads = async () => {
  const response = await fetch(UPLOADS_URL);
  if (response.status !== 200) throw new Error();

  return response.json();
};

export const checkAidentifiedFile = async (tenantId, file) => {
  const response = await fetch(`${UPLOADS_URL}/check`, {
    method: 'POST',
    body: getFormData(tenantId, file),
  });
  if (response.status !== 200) throw await getFileError(response);

  return response.json();
};

export const uploadAidentifiedFile = async (tenantId, file) => {
  const response = await fetch(UPLOADS_URL, {
    method: 'POST',
    body: getFormData(tenantId, file),
  });
  if (response.status !== 200) throw await getFileError(response);

  return response.json();
};

export const getAidentifiedUploadReport = async importId => {
  const response = await fetch(`${UPLOADS_URL}/${importId}`);
  if (response.status !== 200) throw new Error();

  return response.json();
};

export const deleteAidentifiedUpload = async importId => {
  const response = await fetch(`${UPLOADS_URL}/${importId}`, {
    method: 'DELETE',
  });
  if (response.status !== 200) throw new Error();
};

export const downloadAidentifiedTemplate = () =>
  downloadFile(`${UPLOADS_URL}/template`, 'Aidentified template.csv');

export const downloadRowsWithoutLead = ({ importId, fileName }) =>
  downloadFile(
    `${UPLOADS_URL}/${importId}/rows-without-lead`,
    `${fileName.replace(/\.(xlsx|csv)$/i, '')} - rows without a lead.csv`,
  );

// Returns null when the lead has no data.
const getAidentifiedData = async query => {
  const response = await fetch(`/admin/aidentified-data?${query}`);
  if (response.status === 404) return null;
  if (response.status !== 200) throw new Error();

  return response.json();
};

export const getCallAidentifiedData = callRecordingId =>
  getAidentifiedData(`callRecordingId=${callRecordingId}`);

export const getContactAidentifiedData = (tenantId, contactId) =>
  getAidentifiedData(`tenantId=${tenantId}&contactId=${contactId}`);
